import React, { Component } from 'react';
// import { inject , observer} from 'mobx-react'
import { Modal, Button } from 'antd';
// import { store } from 'Store/store.index';
import { isMobile } from 'Utils/device';

export default class NoPdfDialog extends Component {
  constructor(props) {
    super(props);
  }



  render() {
    const { showDialog} = this.props
    return (
      <React.Fragment>
        <div>
          {
            !isMobile && <Modal
              closable = { true }
              title="福昕云编辑"
              visible = { showDialog }
              className = "noPdf"
              footer = {[
                <Button key="submit" type="primary" onClick={this.props.onCancel}>确定</Button>
              ]}
              onCancel= {this.props.onCancel}
            >
              <img  src={require('@/assets/fw_cloud_editor/main/warning.png')} alt="提示" /> <br/>
              <p>
                文件打开失败: 不是一个PDF文件或该文件已损坏。请确<br/>
                认文件路径是否正确。
              </p>
            </Modal>
          }
          {
            isMobile && 
            <div className="fwMobileDialog" onClick={this.props.onCancel}>
              <div className="fwMobileDialogBox"  onClick={(e) =>{e.stopPropagation()}}>
                <div className="fwMobileDialogMain">
                  <img src={require("@/assets/fw_cloud_editor_mobile/img_warnning.png")}></img>
                  <p>
                    文件打开失败: 不是一个PDF文件或该文件已损坏。请确认文件路径是否正确。
                  </p>
                </div>
                <div className="fwMobileDialogBoxFooter">
                  <span className="fwMobileDialogFooterCancel" onClick={this.props.onCancel}>取消</span>
                  <span className="fwMobileDialogFooterOK" onClick={this.props.onCancel}>确定</span>
                </div>
              </div>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}